<template>
    <aside class="analytics-header" v-if="$store.state.user_data && can_start" :key="key_ref">
        <div class="header">
            <div class="title">Analytics</div>
            <Navi :menu="menu" />
            <!-- 在analytics的時候要把他跟header的last_update位子互調(9389) -->
            <Checkbox v-if="can_show_checkbox && show_check_box" size="small" :key="'all'" :label_text="'Include Shortlink Data'" :checked="sortlink_data"
                @click="sortLinkClick" 
                :desc="`This only appears on products that actually have shortlink data associated.  If someone unchecks the box - this should go away and the numbers adjust accordingly. `"
                :had_svg="true"/>
            <div class="update-time" v-else >Last Update:  {{$store.state.user_data.merchant_data_update_hour_ago}}h ago</div>
            <DatePicker class="btn" :date_range="date_range" @update-date="updateDate" @close="isClose"
                :is_post_pick="need_han_date ? true : false" :cus_text="cus_text"/>
            <!-- <Button size="32" @click.native="downloadPdf" :color="'black-60'" :style="'border-square'" class="btn"><SvgIcon name="file-finger" />PDF</Button> -->
        </div>
    </aside>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Navi from '@/components/Navi.vue';
import Button from '@/components/ui/Button.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import moment from 'moment';
import { handleMaxMinFun } from '@/utils/SwitchFun.js';
import Checkbox from '@/components/ui/Checkbox.vue';

export default {
    name: 'AnalyticsHeader',
    emits: ['update_date',],

    components: {
        SvgIcon,
        Navi,
        Button,
        DatePicker,
        Checkbox
    },

    props:{
        data_statistic:{
            type: Object,
            default: null
        },
        show_check_box:{
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            menu: [
                {
                    text: 'Overview',
                    to: '/analytics/overview',
                },
                {
                    text: 'Products',
                    to: '/analytics/product',
                },
                //Collections
                {
                    text: 'Collections',
                    to: '/analytics/collections',
                },
                {
                    text: 'Content',
                    to: '/analytics/content',
                    // for_in:true,
                },
            ],
            key_ref: 0,
            date_range: {
                start_date: moment().add(-30, 'days').toDate(),
                end_date: moment().add(-1, 'days').toDate()
            },
            cus_text:'',
            can_start:false,//阻止有些元件在時間整理完之前出現
            sortlink_data:0,
        }
    },

    computed: {
        need_han_date() {
            return this.$store.state.user_data.contract_status && this.$route.fullPath === '/analytics/content'
        },
        handle_contract_start() {
            return this.need_han_date ? moment(this.$store.state.user_data.contract_start_time).format('YYYY-MM-DD') : this.date_range.start_date;
        },
        plusData(){
            let da=this.data_statistic;
            let can_toggle_sortlink= da ? da.short_link_click_sum + da.short_link_sales_sum + da.short_link_sales_value_sum : 0;
            if(!da){
                return{
                    can_toggle_sortlink:can_toggle_sortlink
                }
            }if(this.sortlink_data){
                return{
                    can_toggle_sortlink:can_toggle_sortlink
                }
                
            }else{
                return{
                    can_toggle_sortlink:can_toggle_sortlink
                }
            }
        },
        //判斷能不能把sortlink展現出來，如果不能，last_time也不能
        can_show_checkbox(){
            return this.can_start &&this.data_statistic && this.plusData.can_toggle_sortlink;
        }
    },

    watch:{
        $route: {
            immediate: true,
            handler(to, from) {
                if(to.fullPath=== '/analytics/content'){
                    this.date_range.start_date = this.need_han_date ? moment(this.$store.state.user_data.contract_start_time).format('YYYY-MM-DD') : this.date_range.start_date;
                    this.date_range.end_date = this.need_han_date ? moment().add(-1, 'days').toDate(): this.date_range.end_date;
                }
            },
        },
    },

    methods: {

        sortLinkClick(){
            this.sortlink_data=this.sortlink_data?  0 : 1;
            this.$emit('handleSortLink', this.sortlink_data );
        },

        downloadPdf() {
            this.$notify({
                title: 'Coming soon',
                type: 'warn',
                duration: 3000,
                group: 'center',
            });
        },
        updateDate(obj) {
            this.date_range.start_date = obj.start_date;
            this.date_range.end_date = obj.end_date;
            this.cus_text=obj.cus;
            
            this.EventBus.emit('update-date-at-analytics', obj);
            this.EventBus.emit('update-date', obj);
            
        },

        isClose() {
            setTimeout(() => {
                this.key_ref += 1;
            }, 100)
        },

        startFunction(){
            let checkTime = handleMaxMinFun( this.date_range.start_date , this.date_range.end_date ,this);
            this.date_range.start_date = checkTime[0];
            this.date_range.end_date = checkTime[1];
            this.sortlink_data = this.init_sortlink!==undefined ? this.init_sortlink : this.$store.state.save_sortlink_data;//放入預設
            this.can_start=true;
        },  
    },

    mounted(){
        this.startFunction();
        // if(this.$route.fullPath === '/analytics/content'){
        //     this.date_range.start_date = this.need_han_date ? moment(this.$store.state.user_data.contract_start_time).format('YYYY-MM-DD') : this.date_range.start_date;
        //     this.date_range.end_date = this.need_han_date ? moment().add(-1, 'days').toDate() : this.date_range.end_date;
        // }
    }
}
</script>
<style lang="scss">
.analytics-header {
    width: 100%;
    overflow: hidden;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
    padding-bottom: 20px;

    .header {
        width: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        // border-bottom: 2px solid var(--black-20);

        .title {
            font: var(--font-demi-36);
            color: black;
        }

        .ui-navi {
            margin-left: 42px;
            flex: 1;
        }

        .ui-checkbox{
            margin: 0;
        }

        .btn {
            margin-left: 20px;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                margin-right: 6px;
            }
        }

        .ui-button {
            cursor: not-allowed;
        }
    }


}
</style>
